export const BASE_CLASS = "l-collapse";

export const getClass= (childClass: TemplateStringsArray) =>
    `${BASE_CLASS}${childClass}`;